import { get, Response } from '.';

export function GetMe(options = {}): Promise<Response<any>> {
  return get<any>('/app/api/me', options);
}
